import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-Acl',
    templateUrl: './Acl.component.html'
})
export class AclComponent implements OnInit {

    consumerID: string;
    whitelist: [];
    blacklist: [];
    hide_groups_header = false;

    data = {
        'consumerID': this.consumerID,
        'whitelist': this.whitelist,
        'blacklist': this.blacklist,
        'hide_groups_header': this.hide_groups_header,
        'plugin': 'acl'
    }
    constructor() { }

    slider() {
        this.hide_groups_header = !this.hide_groups_header;
    }

    ngOnInit() {
    }

}
